import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Vector3, Quaternion } from 'three';
import { mapLayerInstancesToComponents } from '../../lib/stackup';

export class Stackup extends Component {
  constructor(props) {
    super(props);
    this.layers = new Set();
  }

  componentDidMount() {
    const { onObjMounted } = this.props;
    if (onObjMounted !== undefined) {
      onObjMounted(Array.from(this.layers))
    }
  }

  onLayerCreated(layer) {
    if (layer !== null) {
      this.layers.add(layer);
    }
  }

  render() {
    const {
      position,
      quaternion,
      scale,
      layers,
      onLayerClicked,
      setHoveredLayer,
      unSetHoveredLayer,
      freezeMouseEvents
    } = this.props;
    const onCreate = this.onLayerCreated.bind(this)
    const stackup = mapLayerInstancesToComponents(
      layers, onLayerClicked, onCreate, setHoveredLayer, unSetHoveredLayer, freezeMouseEvents
    );

    return (
      <group
        key="stackup"
        position={position}
        quaternion={quaternion}
        scale={scale}
      >
        {stackup}
      </group>
    );
  }
}

Stackup.propTypes = {
  onObjMounted:      PropTypes.func,
  position:          PropTypes.instanceOf(Vector3),
  quaternion:        PropTypes.instanceOf(Quaternion),
  scale:             PropTypes.instanceOf(Vector3),
  layers:            PropTypes.arrayOf(PropTypes.object),
  onLayerClicked:    PropTypes.func,
  setHoveredLayer: PropTypes.func,
  unSetHoveredLayer: PropTypes.func,
  freezeMouseEvents: PropTypes.bool,
}

Stackup.defaultProps = {
  layers: [],
  freezeMouseEvents: false,
  onObjMounted: null,
  scale: new Vector3(1, 1, 1),
  position: null,
  quaternion: null,
  setHoveredLayer: null,
  unSetHoveredLayer: null,
  onLayerClicked: null,
}

export default Stackup;



// WEBPACK FOOTER //
// ./src/components/common/Stackup.js